module.exports = __webpack_public_path__ + "static/media/ic_ex-mark.2a5e0720.svg";